import { createUseStyles } from 'react-jss';

import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { TextColors } from '@picsart/design-system/foundation/colors';
import {
  FontSizes,
  LineHeights,
} from '@picsart/design-system/foundation/typography';

const useStyles = createUseStyles(
  {
    scrollArea: {
      height: '100%',
      overflowY: 'auto',
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: `${Spacings.s12} ${Spacings.s16} max(${Spacings.s16}, env(safe-area-inset-bottom))`,
    },
    title: {
      margin: 0,
      fontSize: FontSizes.t7,
      lineHeight: LineHeights.t7,
      fontWeight: FontWeights.bold,
      color: TextColors.base,
      textAlign: 'center',
    },
    subtitle: {
      margin: [Spacings.s4, 0, Spacings.s24],
      fontSize: FontSizes.t5,
      lineHeight: LineHeights.t5,
      color: TextColors.tint2,
      textAlign: 'center',
    },
    body: {
      width: '100%',
      marginBottom: Spacings.s24,
    },
    primaryButton: {
      borderRadius: CornerRadius.r32,
    },
    cancelButton: {
      marginTop: Spacings.s8,
      fontWeight: FontWeights.semibold,
    },
  },
  { name: 'feed-sheet-layout' }
);

export default useStyles;
